import React, { useEffect, useState } from "react";
import { Grid, Card, Typography, IconButton, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import QuestionIndex from "./Question/QuestionIndex";
import InspectionSummaryIndex from "./Summary/InspectionSummaryIndex";
import "react-awesome-lightbox/build/style.css";
import ImageSlider from "../ReusableComponent/ImageSlider";
import NotFoundCard from "../ReusableComponent/NotFoundCard";
import { useLanguageContext } from "../../Context/LanguageContext";
import { _functionHelper } from "./HelperFunction/HelperFunction";

const useStyles = makeStyles((theme) => ({
  checklistTitle: {
    fontWeight: "bold",
    marginBottom: theme.spacing(1),
  },
  subtitle: {
    fontStyle: "italic",
    marginBottom: theme.spacing(1),
  },
  blockTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "column",
  },
  headerGrid: {
    justifyContent: "space-between",
  },
  headerGrid2: {
    justifyContent: "none",
  },
}));

export default function Blocks({
  handleNextChapter,

  totalChapter,
  activeChapter,
  blocksList,
  resetBlock,
  setResetBlock,
  handleChangeField,
  handleSaveInspection,
  chapterList,
  inspectionImage,
  handleSummaryAction,
  equipmentDetails,
  setIsEquipmentNio,
  isEquipmentNio,
  handleAbort,
  handleCreateTicketFlag,
  isCreateTicketActive,
}) {
  const { localization } = useLanguageContext();
  const classes = useStyles();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isFinshActive, setIsFinshActive] = useState(false);

  const handleBlockNext = (buttonTrack) => {
    const _isrequiredEmpty = _functionHelper.allowNextFromBlock(
      blocksList[selectedIndex]["pruefFragenItemModels"],
      localization.fieldRequired,
      localization.selectoptionDropDown
    );
    if (_isrequiredEmpty) {
      handleChangeField(
        blocksList[selectedIndex]["pruefFragenItemModels"],
        selectedIndex
      );
    } else {
      setSelectedIndex((prev) => prev + 1);
      if (buttonTrack === "finish") {
        setIsFinshActive(true);
      }
    }
  };

  useEffect(() => {
    if (blocksList.length > 0 && blocksList[selectedIndex]) {
      handleChangeField(
        blocksList[selectedIndex]["pruefFragenItemModels"],
        selectedIndex
      );
    }
  }, [blocksList, selectedIndex]);

  useEffect(() => {
    if (resetBlock) {
      if (selectedIndex !== 0) {
        setSelectedIndex(0);
      }
      setIsFinshActive(false);
      setResetBlock(false);
    }
  }, [resetBlock, selectedIndex, setResetBlock]);

  const handleValueChange = (_tempValue) => {
    handleChangeField(_tempValue, selectedIndex);
  };

  const handleCreateTicketQuestionFlag = (questionId) => {
    handleCreateTicketFlag(questionId);
  };

  const renderImages = () => {
    return blocksList[selectedIndex]["files"].map((element) => ({
      image: `data:image/jpg;base64,${element.filecontent}`,
    }));
  };

  return (
    <>
      {!resetBlock &&
        (blocksList.length > 0 ? (
          <Grid container className="card blockContentdisplay" spacing={2}>
            <Grid item xs={12}>
              <Grid
                container
                alignItems="center"
                className={
                  isFinshActive ? classes.headerGrid2 : classes.headerGrid
                }
              >
                <IconButton
                  disabled={!(selectedIndex > 0)}
                  onClick={() => {
                    if (isFinshActive) {
                      setIsFinshActive(false);
                    }
                    setSelectedIndex((prev) => prev - 1);
                  }}
                >
                  <ArrowBackIosIcon />
                </IconButton>

                <Typography variant="h6" className={classes.blockTitle}>
                  {isFinshActive ? (
                    localization.summary
                  ) : (
                    <>
                      <span>
                        {selectedIndex + 1 + "/" + blocksList.length}{" "}
                      </span>
                      <span> {blocksList[selectedIndex]?.["title"]}</span>
                    </>
                  )}
                </Typography>
                {selectedIndex + 1 < blocksList.length && (
                  <IconButton
                    onClick={() => {
                      handleBlockNext("next");
                    }}
                  >
                    <ArrowForwardIosIcon />
                  </IconButton>
                )}
                {selectedIndex + 1 === blocksList.length && (
                  <>
                    {totalChapter - 1 === activeChapter ? (
                      <IconButton
                        onClick={() => {
                          handleBlockNext("next");
                        }}
                        disabled={true}
                      >
                        <ArrowForwardIosIcon />
                      </IconButton>
                    ) : (
                      <Button
                        className="buttonRounded"
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          handleNextChapter(selectedIndex);
                        }}
                      >
                        {localization.nextChapter}
                      </Button>
                    )}
                  </>
                )}
              </Grid>
              {!isFinshActive ? (
                <>
                  {blocksList[selectedIndex]["files"].length > 0 && (
                    <div className="mt-2">
                      <ImageSlider
                        slides={renderImages()}
                        handleImageSelection={() => {}}
                      />
                    </div>
                  )}
                  <QuestionIndex
                    handleChangeField={handleValueChange}
                    questionList={{
                      questions: blocksList[selectedIndex],
                      blocks: blocksList,
                    }}
                    currentBlock={0}
                    showCanCreateTicketCheckbox={isFinshActive}
                  />
                  {selectedIndex + 1 === blocksList.length && (
                    <div className="row justify-content-center ml-0 mr-0">
                      {totalChapter - 1 === activeChapter ? (
                        <Button
                          className="buttonRounded"
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            handleBlockNext("finish");
                          }}
                        >
                          {localization.finish}
                        </Button>
                      ) : (
                        <Button
                          className="buttonRounded"
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            handleNextChapter(selectedIndex);
                          }}
                        >
                          {localization.nextChapter}
                        </Button>
                      )}
                    </div>
                  )}
                </>
              ) : (
                <InspectionSummaryIndex
                  handleSaveInspection={handleSaveInspection}
                  blocksList={blocksList}
                  chapterList={chapterList["checklistChapterModels"]}
                  isInspectionRequired={{
                    isImage: chapterList["photoNeeded"],
                    isFeedBack: chapterList["isChecklistFeedbackMandatory"],
                    isCheckListCritical:
                      chapterList["shouldTakeEquipmentOutOfOrder"],
                  }}
                  inspectionImage={inspectionImage}
                  handleSummaryAction={handleSummaryAction}
                  equipmentDetails={equipmentDetails}
                  setIsEquipmentNio={setIsEquipmentNio}
                  isEquipmentNio={isEquipmentNio}
                  handleAbort={handleAbort}
                  handleCreateTicketCheckboxChange={
                    handleCreateTicketQuestionFlag
                  }
                  showCanCreateTicketCheckbox={isFinshActive}
                  isCreateTicketActive={isCreateTicketActive}
                />
              )}
            </Grid>
          </Grid>
        ) : (
          <NotFoundCard title={localization.noBlock} />
        ))}
    </>
  );
}
